// when updating a value in this file, don't forget to also update
// "apps/front/commonConfig/next-18next.config.js" and "libs/front/storybook/.storybook/i18next.js" file as well

// Language
export const locales = ['fr', 'en', 'de', 'es', 'nl'] as const
export type Locale = (typeof locales)[number]
const defaultLocale: Locale = 'fr'

export const isKnownLocale = function (lang: string): lang is Locale {
  // @ts-expect-error error if lang !== Locale, we need this type guard to raise this
  return locales.includes(lang)
}
interface Language {
  id: number
  locale: Locale
  flag: string
}

export const localeLanguageMapping: Record<Locale, Language> = {
  fr: {
    id: 1,
    locale: 'fr',
    flag: '🇫🇷',
  },
  en: {
    id: 2,
    locale: 'en',
    flag: '🇬🇧',
  },
  de: {
    id: 3,
    locale: 'de',
    flag: '🇩🇪',
  },
  es: {
    id: 4,
    locale: 'es',
    flag: '🇪🇸',
  },
  nl: {
    id: 5,
    locale: 'nl',
    flag: '🇳🇱',
  },
}

export const availableLanguages = Object.values(localeLanguageMapping)

export const getIdLanguageFromLocale = (lang: string): number => {
  if (isKnownLocale(lang)) {
    return localeLanguageMapping[lang].id
  }
  return localeLanguageMapping[defaultLocale].id
}

export const getLocaleFromLanguageId = (languageId: number): string => {
  const language = availableLanguages.find((e) => e.id === languageId)
  if (language) {
    return language.locale
  }
  return defaultLocale
}
